/* ==========================================================================
   LUNDRA — Fiche produit : vignettes, fenêtre de livraison, clips vidéo.
   L'ajout au panier reste géré par lundra-selecteur.js.
   ========================================================================== */
(function () {
  'use strict';

  /* ----------------------------------------------------------------------
     1. Vignettes de la galerie
     ---------------------------------------------------------------------- */
  function initVignettes(racine) {
    var vignettes = racine.querySelectorAll('[data-lu-vignette]');
    if (!vignettes.length) return;
    var vues = racine.querySelectorAll('[data-lu-vue]');
    var options = racine.querySelectorAll('input[type="radio"][data-lu-items]');

    function marquer(cle) {
      vignettes.forEach(function (v) {
        var actif = v.getAttribute('data-lu-vignette') === cle;
        v.classList.toggle('est-active', actif);
        v.setAttribute('aria-pressed', actif ? 'true' : 'false');
      });
    }

    function afficher(cle) {
      vues.forEach(function (v) {
        var actif = v.getAttribute('data-lu-vue') === cle;
        v.classList.toggle('est-active', actif);
        v.setAttribute('aria-hidden', actif ? 'false' : 'true');
      });
      marquer(cle);
    }

    vignettes.forEach(function (v) {
      v.addEventListener('click', function () {
        var cle = v.getAttribute('data-lu-vignette');
        var offre = null;
        options.forEach(function (o) { if (o.value === cle) offre = o; });
        if (offre) {
          offre.checked = true;
          offre.dispatchEvent(new Event('change', { bubbles: true }));
          marquer(cle);
        } else {
          afficher(cle);
        }
      });
    });

    options.forEach(function (o) {
      o.addEventListener('change', function () { if (o.checked) marquer(o.value); });
    });

    var coche = null;
    options.forEach(function (o) { if (o.checked) coche = o; });
    if (coche) marquer(coche.value);
  }

  /* ----------------------------------------------------------------------
     2. Fenêtre de livraison
     Le délai annoncé en jours ouvrés devient des dates réelles.
     Aucune promesse nouvelle : c'est le même délai, simplement daté.
     ---------------------------------------------------------------------- */
  function ajouterJoursOuvres(depart, nombre) {
    var d = new Date(depart.getTime());
    var restants = nombre;
    while (restants > 0) {
      d.setDate(d.getDate() + 1);
      var jour = d.getDay();
      if (jour !== 0 && jour !== 6) restants--;
    }
    return d;
  }

  function initDelai(racine) {
    var bloc = racine.querySelector('[data-lu-delai]');
    if (!bloc) return;

    var min = parseInt(bloc.getAttribute('data-lu-min'), 10);
    var max = parseInt(bloc.getAttribute('data-lu-max'), 10);
    if (!min || !max || max < min) return;

    var langue = document.documentElement.lang || 'fr';
    var opts = { day: 'numeric', month: 'long' };
    var aujourdhui = new Date();
    var debut = ajouterJoursOuvres(aujourdhui, min);
    var fin = ajouterJoursOuvres(aujourdhui, max);

    function formater(date) {
      try { return date.toLocaleDateString(langue, opts); }
      catch (e) { return date.toLocaleDateString(); }
    }

    function formaterPlage(a, b) {
      try {
        var fmt = new Intl.DateTimeFormat(langue, opts);
        if (typeof fmt.formatRange === 'function') return fmt.formatRange(a, b);
      } catch (e) {}
      return formater(a) + ' – ' + formater(b);
    }

    var champJour = bloc.querySelector('[data-lu-delai-aujourdhui]');
    if (champJour) champJour.textContent = formater(aujourdhui);

    var champFenetre = bloc.querySelector('[data-lu-delai-fenetre]');
    if (champFenetre) champFenetre.textContent = formaterPlage(debut, fin);

    bloc.classList.add('est-date');
  }

  /* ----------------------------------------------------------------------
     3. Clips vidéo
     Toujours à l'arrêt au chargement. Le bouton maison lance la lecture,
     puis les contrôles natifs prennent le relais. Lancer un clip met
     l'autre en pause.
     ---------------------------------------------------------------------- */
  function initClips(racine) {
    var clips = racine.querySelectorAll('[data-lu-clip]');
    if (!clips.length) return;

    clips.forEach(function (clip) {
      var video = clip.querySelector('video');
      var bouton = clip.querySelector('[data-lu-clip-play]');
      if (!video || !bouton || clip.dataset.luPret) return;
      clip.dataset.luPret = '1';

      video.removeAttribute('autoplay');
      video.playsInline = true;
      video.setAttribute('playsinline', '');

      bouton.addEventListener('click', function () {
        clips.forEach(function (autre) {
          if (autre === clip) return;
          var v = autre.querySelector('video');
          if (v && !v.paused) v.pause();
        });
        var promesse = video.play();
        if (promesse && typeof promesse.catch === 'function') {
          promesse.catch(function () { clip.classList.remove('est-lance'); });
        }
      });

      video.addEventListener('play', function () { clip.classList.add('est-lance'); });
      video.addEventListener('pause', function () { clip.classList.remove('est-lance'); });
      video.addEventListener('ended', function () { clip.classList.remove('est-lance'); });
    });
  }

  function demarrer() {
    document.querySelectorAll('[data-lu-fiche]').forEach(function (racine) {
      initVignettes(racine);
      initDelai(racine);
      initClips(racine);
    });
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', demarrer);
  } else {
    demarrer();
  }

  document.addEventListener('shopify:section:load', demarrer);
})();
